<!-- <ion-header class="ion-no-border">
    <ion-title>
        &nbsp;<ion-label>{{"add_your_comment" | translate}}</ion-label>&nbsp;
    </ion-title>
 <ion-icon src="../../../assets/svg/close.svg" (click)="closeModal()"
        class="close-button button-clear">
    </ion-icon>
</ion-header> -->

<ion-card class="headmodal">
    <span class="titlemodal">
        {{"add_your_comment" | translate}}
    </span>
    <ion-button class="close-button" (click)="closeModal()">
        <ion-icon color="primary" name="close-outline"></ion-icon>
    </ion-button>
</ion-card >

    <ion-card class="ion-text-start openclear nomargin contentcard">
        
        <form [formGroup]="commentForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <ion-input type="hidden" class="hideThis" [(ngModel)]="customer_id" formControlName="customer_id"></ion-input>
            <ion-input type="hidden"  class="hideThis" [(ngModel)]="post_id" formControlName="post_id"></ion-input>
            <ion-textarea class="popleft" formControlName="content" rows="5" placeholder="{{'enter_comments' | translate}}"
                [autoGrow]="true">
            </ion-textarea>
            <ion-button type="submit" shape="round" fill="solid" expand="full">
                <ng-container *ngIf="loading">
                    <ion-spinner dir="ltr" name="dots"></ion-spinner>
                </ng-container>
                {{"submit" | translate}}
            </ion-button>
        </form>
    </ion-card>
